import { type ConfluencePage } from '@atlassian/search-client/recommended-documents/types';
import { type SmartsRecommendedObjectData } from '@atlassian/search-client/user-documents/types';

import type { EnrichedRecommendedDocument } from '../../../../common/ui/quick-find/types';

export const isConfluenceRecommendation = (
	result: EnrichedRecommendedDocument,
): result is EnrichedRecommendedDocument & {
	object: ConfluencePage | SmartsRecommendedObjectData;
} => {
	return (
		result?.object?.__typename === 'ConfluencePage' ||
		result?.object?.__typename === 'ConfluenceBlogPost'
	);
};
